import React from "react";
import dodge from "../assets/cars/dodge.png";
import mg from "../assets/cars/mg.png";
import landrover from "../assets/cars/landrover.png";
import nissan from "../assets/cars/nissan.png";
import kia from "../assets/cars/kia.png";
import hyundai from "../assets/cars/hyundai.png";
import toyota from "../assets/cars/toyota.png";

const brands = [
  { name: "Dodge", logo: dodge },
  { name: "MG", logo: mg },
  { name: "Land Rover", logo: landrover },
  { name: "Nissan", logo: nissan },
  { name: "Kia", logo: kia },
  { name: "Hyundai", logo: hyundai },
  { name: "Toyota", logo: toyota },
];

const OurBrands = () => {
  return (
    <section id="brands" className="py-16 px-4 sm:px-10 lg:px-20 bg-gray-50 overflow-hidden">
      <div className="container mx-auto text-center">
        {/* Section Title */}
        <h2 className="text-2xl sm:text-3xl font-bold text-[#0B2F6B] mb-10">
          OUR BRANDS
        </h2>

        {/* Carousel */}
        <div className="relative w-full overflow-hidden">
          <div className="flex animate-marquee-sm sm:animate-marquee hover:[animation-play-state:paused]">
            {/* Duplicate logos twice for seamless looping */}
            {[...brands, ...brands].map((brand, index) => (
              <div
                key={index}
                className="flex-shrink-0 mx-4 sm:mx-6 bg-white rounded-xl border-gray-500 shadow-lg p-4 sm:p-6 flex items-center justify-center w-24 h-20 sm:w-32 sm:h-24 lg:w-40 lg:h-28"
              >
                <img
                  src={brand.logo}
                  alt={brand.name}
                  className="max-h-10 sm:max-h-12 lg:max-h-16 object-contain"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurBrands;
